export default __webpack_public_path__ + "static/media/hackathon.f6713615.jpeg";